import { stripHtml } from './stripHtml';

export const decodeString = (encodedStr: string) => {
    try {
        return decodeURIComponent(stripHtml(encodedStr as string) as string);
    } catch (error) {
        console.warn('[Search] Error decoding URI:', encodedStr, error);
        return encodedStr;
    }
};
